import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';
import { GUNCEL_AY, cozGuncelAy } from '../utils/guncelAy';

const API  = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const tkn  = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const YIL   = new Date().getFullYear();

const emptyForm = {
  isletme_id: '', yil: YIL, ay: new Date().getMonth() + 1,
  tur: '', irk: '', irk_kod: '',
  yillik_sut_uretim_kg: 0, ana_hayvan_sayisi: 0, sagmal_hayvan_sayisi: 0,
  sagmal_orani: 0, sagmal_ortalamasi: 0, ahir_ortalamasi: 0,
  harici_satilan_kg: 0, personele_satilan_kg: 0,
  imalatta_kullanilan_kg: 0, buzagiya_icirilen_kg: 0,
};

async function getTanimlar(url: string) {
  const r = await fetch(`${API}${url}`, { headers: tkn() });
  return r.ok ? r.json() : [];
}

export default function SutUretimi() {
  // Kullanıcı bilgisi hook'lardan önce hesaplanır; lazy initializer için gerekli
  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = !!(user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol));
  const isAdmin = !!(user?.rol && ['super_admin', 'gm_yonetici'].includes(user.rol));
  const kisitliIsletmeId: any = !isGM && user?.isletme_id ? user.isletme_id : '';

  const [kayitlar,    setKayitlar]    = useState<any[]>([]);
  const [isletmeler,  setIsletmeler]  = useState<any[]>([]);
  const [ozet,        setOzet]        = useState<any>(null);
  // İşletme kullanıcısı için başlangıçta kendi isletme_id'si atanır (race condition yok)
  const [filtre,      setFiltre]      = useState({ isletme_id: kisitliIsletmeId, yil: YIL, ay: GUNCEL_AY as any, tur: '' });
  const [cozulenAy,   setCozulenAy]   = useState<number | null>(null);
  const [modalAcik,   setModalAcik]   = useState(false);
  const [secili,      setSecili]      = useState<any>(null);
  const [form,        setForm]        = useState<any>({ ...emptyForm, isletme_id: kisitliIsletmeId || '' });
  const [hata,        setHata]        = useState('');
  const [yukleniyor,  setYukleniyor]  = useState(false);
  const [kiralikGoster, setKiralikGoster] = useState(false);

  const [bbIrklar,   setBbIrklar]   = useState<any[]>([]);
  const [koyunIrklar, setKoyunIrklar] = useState<any[]>([]);
  const [keciIrklar,  setKeciIrklar]  = useState<any[]>([]);

  useEffect(() => {
    getTanimlar('/api/tanimlar2/liste?modul=buyukbas_irk&sadece_yaprak=true').then(setBbIrklar);
    getTanimlar('/api/tanimlar2/liste?ust=H.2.1.1&sadece_yaprak=true').then(setKoyunIrklar);
    getTanimlar('/api/tanimlar2/liste?ust=H.2.1.2&sadece_yaprak=true').then(setKeciIrklar);
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster)
      .then(r => setIsletmeler(r.data || []))
      .catch(() => {});
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const irkListesi = () => {
    if (form.tur === 'SIĞIR') return bbIrklar;
    if (form.tur === 'KOYUN') return koyunIrklar;
    if (form.tur === 'KEÇİ')  return keciIrklar;
    return [];
  };

  const yukle = async () => {
    let ay = filtre.ay;
    if (ay === GUNCEL_AY) {
      ay = await cozGuncelAy(filtre.yil, filtre.isletme_id, (p: any) =>
        axios.get(`${API}/api/hayvancilik/sut-uretimi`, { headers: tkn(), params: p }));
      setCozulenAy(ay);
    } else {
      setCozulenAy(null);
    }
    const params: any = { yil: filtre.yil };
    if (filtre.isletme_id) params.isletme_id = filtre.isletme_id;
    if (ay)                params.ay = ay;
    if (filtre.tur)        params.tur = filtre.tur;
    try {
      const [listRes, ozetRes] = await Promise.all([
        axios.get(`${API}/api/hayvancilik/sut-uretimi`, { headers: tkn(), params }),
        axios.get(`${API}/api/hayvancilik/sut-uretimi/ozet`, { headers: tkn(), params }),
      ]);
      setKayitlar(listRes.data || []);
      setOzet(ozetRes.data);
    } catch { setKayitlar([]); }
  };

  const duzenleAc = (r: any) => {
    setSecili(r);
    setForm({ ...r, irk: r.irk || '', irk_kod: r.irk_kod || '' });
    setHata(''); setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    if (!form.tur)        { setHata('Tür seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      const irkBulunan = irkListesi().find((i: any) => i.kod === form.irk_kod);
      const body = {
        ...form,
        isletme_id: Number(form.isletme_id),
        irk: irkBulunan ? irkBulunan.ad : (form.irk || null),
        irk_kod: form.irk_kod || null,
        yil: Number(form.yil), ay: Number(form.ay),
      };
      if (secili) {
        await axios.put(`${API}/api/hayvancilik/sut-uretimi/${secili.id}`, body, { headers: tkn() });
      } else {
        await axios.post(`${API}/api/hayvancilik/sut-uretimi`, body, { headers: tkn() });
      }
      yukle(); setModalAcik(false); setSecili(null); setForm({ ...emptyForm });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu kaydı silmek istiyor musunuz?')) return;
    try { await axios.delete(`${API}/api/hayvancilik/sut-uretimi/${id}`, { headers: tkn() }); yukle(); } catch {}
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) { try { await axios.delete(`${API}/api/hayvancilik/sut-uretimi/${k.id}`, { headers: tkn() }); } catch {} }
    yukle();
  };

  const n = (v: any, d = 0) => v == null ? '—' : d > 0 ? Number(v).toFixed(d) : Number(v).toLocaleString('tr-TR');

  const sutColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'tur', label: 'Tür', sortable: true, filterable: true, render: (k: any) => <span style={{ background: k.tur === 'SIĞIR' ? '#d6eaf8' : k.tur === 'KOYUN' ? '#d5f5e3' : '#fef9e7', color: k.tur === 'SIĞIR' ? '#1a5276' : k.tur === 'KOYUN' ? '#1e8449' : '#9a7d0a', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>{k.tur}</span>, filterValue: (k: any) => k.tur || '' },
    { key: 'irk', label: 'Irk', sortable: true, filterable: true, render: (k: any) => k.irk || '—', filterValue: (k: any) => k.irk || '' },
    { key: 'uretim', label: 'Üretim (kg)', sortable: true, render: (k: any) => n(k.yillik_sut_uretim_kg), sortValue: (k: any) => Number(k.yillik_sut_uretim_kg || 0) },
    { key: 'ana_hayvan', label: 'Ana Hayvan', sortable: true, render: (k: any) => n(k.ana_hayvan_sayisi), sortValue: (k: any) => Number(k.ana_hayvan_sayisi || 0) },
    { key: 'sagmal', label: 'Sağmal', sortable: true, render: (k: any) => n(k.sagmal_hayvan_sayisi), sortValue: (k: any) => Number(k.sagmal_hayvan_sayisi || 0) },
    { key: 'sagmal_ort', label: 'Sağmal Ort.', sortable: true, render: (k: any) => n(k.sagmal_ortalamasi, 2), sortValue: (k: any) => Number(k.sagmal_ortalamasi || 0) },
    { key: 'ahir_ort', label: 'Ahır Ort.', sortable: true, render: (k: any) => n(k.ahir_ortalamasi, 2), sortValue: (k: any) => Number(k.ahir_ortalamasi || 0) },
    { key: 'harici', label: 'Harici Sat.', sortable: true, render: (k: any) => n(k.harici_satilan_kg), sortValue: (k: any) => Number(k.harici_satilan_kg || 0) },
    { key: 'personel', label: 'Personel', sortable: true, render: (k: any) => n(k.personele_satilan_kg), sortValue: (k: any) => Number(k.personele_satilan_kg || 0) },
    { key: 'imalat', label: 'İmalat', sortable: true, render: (k: any) => n(k.imalatta_kullanilan_kg), sortValue: (k: any) => Number(k.imalatta_kullanilan_kg || 0) },
    { key: 'buzagi', label: 'Buzağı/Kuzu', sortable: true, render: (k: any) => n(k.buzagiya_icirilen_kg), sortValue: (k: any) => Number(k.buzagiya_icirilen_kg || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  return (
    <div>
      <div className="page-header">
        <h1>🥛 Süt Üretimi</h1>
        <p>Büyükbaş ve küçükbaş süt üretim kayıtları</p>
      </div>

      {/* ── ÖZET KARTLAR ── */}
      {ozet && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">🥛</div>
            <div><div className="stat-value">{n(Math.round(ozet.toplam_uretim_kg))}</div><div className="stat-label">Toplam Üretim (kg)</div></div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🐄</div>
            <div><div className="stat-value">{n(ozet.toplam_ana_hayvan)}</div><div className="stat-label">Ana Hayvan (baş)</div></div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🍼</div>
            <div><div className="stat-value">{n(ozet.toplam_sagmal)}</div><div className="stat-label">Sağmal Hayvan (baş)</div></div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💰</div>
            <div><div className="stat-value">{n(Math.round(ozet.toplam_harici_satis))}</div><div className="stat-label">Harici Satış (kg)</div></div>
          </div>
        </div>
      )}

      {/* ── ARAÇ ÇUBUĞU + TABLO ── */}
      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 140 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value={GUNCEL_AY}>Güncel Ay{cozulenAy ? ` (${AYLAR[cozulenAy]})` : ''}</option>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            <select className="search-input" style={{ width: 120 }} value={filtre.tur}
              onChange={e => setFiltre({ ...filtre, tur: e.target.value })}>
              <option value="">Tüm Türler</option>
              <option value="SIĞIR">SIĞIR</option>
              <option value="KOYUN">KOYUN</option>
              <option value="KEÇİ">KEÇİ</option>
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 200 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map((i: any) => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-success"
              onClick={() => { setSecili(null); setForm({ ...emptyForm, isletme_id: isGM ? '' : user?.isletme_id }); setHata(''); setModalAcik(true); }}>
              + Yeni Kayıt
            </button>
          </div>
        </div>

        <DataTable columns={sutColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="sut-uretimi" />
      </div>

      {/* ── MODAL FORM ── */}
      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 660 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🥛 {secili ? 'Süt Üretimi Güncelle' : 'Yeni Süt Üretimi Kaydı'}</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              <div className="form-row">
                {isGM && (
                  <div className="form-group">
                    <label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id}
                      onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map((i: any) => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <label>Tür *</label>
                  <select className="form-control" value={form.tur}
                    onChange={e => setForm({ ...form, tur: e.target.value, irk: '', irk_kod: '' })}>
                    <option value="">Seçiniz</option>
                    <option value="SIĞIR">SIĞIR</option>
                    <option value="KOYUN">KOYUN</option>
                    <option value="KEÇİ">KEÇİ</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Yıl *</label>
                  <input className="form-control" type="number" value={form.yil}
                    onChange={e => setForm({ ...form, yil: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Ay *</label>
                  <select className="form-control" value={form.ay}
                    onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Irk <small style={{ color: '#999', fontWeight: 'normal' }}>
                    {irkListesi().length > 0 ? `(${irkListesi().length} ırk)` : '(Önce tür seçin)'}
                  </small></label>
                  <select className="form-control" value={form.irk_kod}
                    onChange={e => setForm({ ...form, irk_kod: e.target.value })}
                    disabled={irkListesi().length === 0}>
                    <option value="">— Seçiniz —</option>
                    {irkListesi().map((irk: any) => (
                      <option key={irk.kod} value={irk.kod}>{irk.ad} ({irk.kod})</option>
                    ))}
                  </select>
                </div>
                <div className="form-group" />
              </div>

              <p style={{ fontWeight: 700, fontSize: 13, color: '#1a5276', marginBottom: 8, marginTop: 8 }}>Süt Üretimi</p>
              <div className="form-row">
                <div className="form-group">
                  <label>Yıllık Süt Üretim (kg)</label>
                  <input className="form-control" type="number" value={form.yillik_sut_uretim_kg}
                    onChange={e => setForm({ ...form, yillik_sut_uretim_kg: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Ana Hayvan Sayısı (baş)</label>
                  <input className="form-control" type="number" value={form.ana_hayvan_sayisi}
                    onChange={e => setForm({ ...form, ana_hayvan_sayisi: Number(e.target.value) })} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Sağmal Hayvan Sayısı (baş)</label>
                  <input className="form-control" type="number" value={form.sagmal_hayvan_sayisi}
                    onChange={e => setForm({ ...form, sagmal_hayvan_sayisi: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Sağmal Oranı (%)</label>
                  <input className="form-control" type="number" step="0.01" value={form.sagmal_orani}
                    onChange={e => setForm({ ...form, sagmal_orani: Number(e.target.value) })} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Sağmal Ortalaması (kg/baş-gün)</label>
                  <input className="form-control" type="number" step="0.01" value={form.sagmal_ortalamasi}
                    onChange={e => setForm({ ...form, sagmal_ortalamasi: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Ahır Ortalaması (kg/baş-gün)</label>
                  <input className="form-control" type="number" step="0.01" value={form.ahir_ortalamasi}
                    onChange={e => setForm({ ...form, ahir_ortalamasi: Number(e.target.value) })} />
                </div>
              </div>

              <p style={{ fontWeight: 700, fontSize: 13, color: '#1a5276', marginBottom: 8, marginTop: 12 }}>Süt Dağılımı</p>
              <div className="form-row">
                <div className="form-group">
                  <label>Harici Satılan (kg)</label>
                  <input className="form-control" type="number" value={form.harici_satilan_kg}
                    onChange={e => setForm({ ...form, harici_satilan_kg: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Personele Satılan (kg)</label>
                  <input className="form-control" type="number" value={form.personele_satilan_kg}
                    onChange={e => setForm({ ...form, personele_satilan_kg: Number(e.target.value) })} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>İmalatta Kullanılan (kg)</label>
                  <input className="form-control" type="number" value={form.imalatta_kullanilan_kg}
                    onChange={e => setForm({ ...form, imalatta_kullanilan_kg: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Buzağıya/Kuzuya İçirilen (kg)</label>
                  <input className="form-control" type="number" value={form.buzagiya_icirilen_kg}
                    onChange={e => setForm({ ...form, buzagiya_icirilen_kg: Number(e.target.value) })} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
